// OCR via Tesseract.js (WASM) — replaces the native Tesseract 5 engine.
// Language data ("nld" = Dutch, matching the original tessdata) is fetched from a
// CDN on first use and cached in IndexedDB by Tesseract.js itself.
import { createWorker, type Worker } from 'tesseract.js'

const DEFAULT_LANG = 'nld'

let workerPromise: Promise<Worker> | null = null
let progressHandler: ((status: string, progress: number) => void) | null = null

/** Register a callback for OCR progress (language download + recognition). */
export function setOcrProgressHandler(cb: (status: string, progress: number) => void): void {
  progressHandler = cb
}

export function preloadOcr(lang: string = DEFAULT_LANG): Promise<Worker> {
  if (!workerPromise) {
    workerPromise = createWorker(lang, 1, {
      logger: (m: { status: string; progress: number }) => progressHandler?.(m.status, m.progress),
    })
  }
  return workerPromise
}

/** OCR an image source (canvas, image, or bitmap). */
export async function ocr(source: HTMLCanvasElement | HTMLImageElement | ImageBitmap): Promise<string> {
  const worker = await preloadOcr()
  const result = await worker.recognize(source as Tesseract.ImageLike)
  return result.data.text
}

export async function disposeOcr(): Promise<void> {
  if (workerPromise) {
    const worker = await workerPromise
    await worker.terminate()
    workerPromise = null
  }
}
